var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-tip",attrs:{"aria-hidden":"true"}},[_c('p',{staticClass:"txt"},[_vm._v(_vm._s(_vm.txt||"继续滑动查看图文详情"))])])}
var staticRenderFns = []

export { render, staticRenderFns }